export function nav() {
  const spNavTrigger = document.querySelector('.js-nav-trigger');
  if(spNavTrigger) {
    spNavTrigger.addEventListener('click', (e) => {
      if(document.body.classList.contains('is-nav-active')){
        document.body.classList.remove('is-nav-active');
      } else {
        document.body.classList.add('is-nav-active');
      }
      e.preventDefault();
    });
  }
  const overlay = document.querySelector('.js-state-reset');
  if(overlay) {
    overlay.addEventListener('click', (e) => {
      document.body.classList.remove('is-nav-active');
      e.preventDefault();
    });
  }
}